import { Ticket, TicketStatus, TicketSite } from '../../../entities/ticket/model/types';
import { updateTicket as updateTicketApi } from '../../../entities/ticket/api/ticketApi';

export interface UpdateTicketRequest {
  ticketId: string;
  data: {
    status?: TicketStatus;
    site?: TicketSite;
    category?: string | undefined;
  };
}

export class UpdateTicketUseCase {
  async execute(request: UpdateTicketRequest): Promise<Ticket> {
    return await updateTicketApi(request.ticketId, request.data);
  }
}

